export function initializePendo(userDetails, environmentName) {
    if (window.pendo) {
        const visitor = {
            id: userDetails?.uid,
            userName: userDetails?.userName ? userDetails?.userName : "",
            userType: userDetails?.userType ? userDetails?.userType : "",
            sellerServicerCoNo: userDetails?.sellerServicerCoNo ? userDetails?.sellerServicerCoNo : "",
            location: userDetails?.location ? userDetails?.location : "",
            isInternalUser: userDetails?.isInternalUser ? userDetails?.isInternalUser : "",
            isFannieMaeUser: userDetails?.isFannieMaeUser ? userDetails?.isFannieMaeUser : "",
            isExternalUser: userDetails?.isExternalUser ? userDetails?.isExternalUser : "",
            groups: userDetails?.groups ? userDetails?.groups : [],
            department: userDetails?.department ? userDetails?.department : "",
            corporateFamilyCode: userDetails?.corporateFamilyCode ? userDetails?.corporateFamilyCode : "",
            customerName: userDetails?.customerName ? userDetails?.customerName : "",
            environment: environmentName ? environmentName : 'unknown'
        }

        const account = {
            id: "CPM",
            mornetPlusId: userDetails?.mornetPlusId ? userDetails?.mornetPlusId : "",
            mornetParntSubscrberId: userDetails?.mornetParntSubscrberId ? userDetails?.mornetParntSubscrberId : "",
            parentId: userDetails?.parentId ? userDetails?.parentId : "",
            institutionNameDefault: userDetails?.institutionNameDefault ? userDetails?.institutionNameDefault : "",
            institutionId: userDetails?.institutionId ? userDetails?.institutionId : "",
        }
        window.pendo.initialize({
            visitor: visitor,
            account: account
        });
    } else {
        console.error('Pendo is not initialized.');
    }
}

// this method is for generating custom pendo events
export function trackEvent(eventName, metadata) {
    var pendo = window.pendo;
    if (pendo) {
        pendo.track(eventName, metadata);
    } else {
        console.error('Pendo is not initialized.');
    }
}